import { render, staticRenderFns } from "./UseTerm.vue?vue&type=template&id=bc42e50e"
import script from "./UseTerm.vue?vue&type=script&lang=js"
export * from "./UseTerm.vue?vue&type=script&lang=js"
import style0 from "./UseTerm.vue?vue&type=style&index=0&id=bc42e50e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports